import DomainEntity from '@/models/DomainEntity'

export default class StateCommunications extends DomainEntity {
  static get collectionName() {
    return 'statecommunications/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
